import React from 'react';
import styled from 'styled-components';
 
const Article = styled.article`
    @keyframes placeHolderShimmer { 
        0% {
            background-position: -468px 0;
        }
        100% {
            background-position: 468px 0;
        }
    }
    
    -webkit-animation-duration: 1s;
    -webkit-animation-fill-mode: forwards;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-name: placeHolderShimmer;
    -webkit-animation-timing-function: linear;
    background: #f6f7f9;
    background-image: linear-gradient(to right, #f6f7f9 0%, #e9ebee 20%, #f6f7f9 40%, #f6f7f9 100%);
    background-repeat: no-repeat;
    margin-top: 1em;
    height: 400px;
    padding: 1em;
    // position: relative;
  `

  function SmallShimmer(props) {
      return (
            <Article>
                {props.children}
            </Article>
      )
  }
  
  export default SmallShimmer;